import React, { useState } from 'react';
import { Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { useRouteMatch, useHistory } from 'react-router-dom';
import AffinityGroupsTable from '../Components/AffinityGroupsTable';
import DeleteModal from "../../../../Util/DeleteModal";
import { useBoolean } from '@fluentui/react-hooks';
import ErrorComponent from '../../../../Util/ErrorComponent';
import SuccessComponent from '../../../../Util/SuccessComponent';

const DefaultPage = () => {
    const [selectedAffinityGroup, setSelectedAffinityGroup] = useState(undefined);
    const [selectedAffinityGroupTitle, setSelectedAffinityGroupTitle] = useState("");
    const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    let { url } = useRouteMatch();
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data: affinityGroups, loading }, refetch] = useAxios("resources/content/admin/affinity-groups");

    if (loading) return <Spinner className="absolute-center" label="Loading Affinity Groups..." />;

    return (
        <>
            <SuccessComponent
                successMessage="Affinity Group Deleted."
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
            />
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            <AffinityGroupsTable
                affinityGroups={affinityGroups && affinityGroups.length > 0 ? affinityGroups.sort((a, b) => b.affinityGroupSettingId - a.affinityGroupSettingId) : []}
                setSelectedAffinityGroup={setSelectedAffinityGroup}
                selectedAffinityGroup={selectedAffinityGroup}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                deleteOnClick={(id, title) => {
                    setSelectedAffinityGroup(id);
                    setSelectedAffinityGroupTitle(title || "");
                    toggleDeleteModal();
                }}
                refetch={refetch}
                loading={loading}
            />
            <DeleteModal
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetch()}
                setErrorMsg={setErrorMsg}
                setShowError={setShowError}
                setShowSuccess={setShowSuccess}
                deleteUrl={`resources/content/admin/affinity-groups/delete/${selectedAffinityGroup}/`}
                resourceName={selectedAffinityGroupTitle}
                resourceType="affinity group"
                confirmationValue={selectedAffinityGroupTitle || undefined}
            />
        </>
    );
};

export default DefaultPage;
